/**
 * Product Recommendations - Moon Moon Agency
 * Custom element for lazy-loaded product recommendations
 */

/*********************************************************************************************
 * 🛒 PRODUCT RECOMMENDATIONS MODULE
 */
class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			window.emit('product-recommendations-loading');

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const html = document.createElement('div');
					html.innerHTML = text;
					const recommendations = html.querySelector('product-recommendations');

					if (recommendations && recommendations.innerHTML.trim().length) {
						this.innerHTML = recommendations.innerHTML;

						// Reinitialize wishlist for new product cards
						if (window.wishlistManager) {
							window.wishlistManager.initButtons();
						}

						window.emit('product-recommendations-loaded');
					} else {
						const parentElement = this.closest('.mm-section');
						if (parentElement) {
							parentElement.style.display = 'none';
						}
						window.emit('product-recommendations-empty');
					}
				})
				.catch((error) => {
					window.log('error', '🛍️ [PRODUCT_RECO]', 'Failed to load product recommendations', { error: error.message });
					window.emit('product-recommendations-error', { error: error.message });
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), { 
			rootMargin: '0px 0px 400px 0px' 
		}).observe(this);
	}
}

/*********************************************************************************************
 * 🎯 INITIALIZATION
 */
// Register custom element
customElements.define('product-recommendations', ProductRecommendations);

// Global access
window.ProductRecommendations = ProductRecommendations;